import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=27ab1a77&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ab1a77')) {
      api.createRecord('27ab1a77', component.options)
    } else {
      api.reload('27ab1a77', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=27ab1a77&", function () {
      api.rerender('27ab1a77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NzjIhL0ZGxcb/JS/comp/currencymod.vue"
export default component.exports